import { useState, useEffect } from "react";

/**
 * Custom debounce hook
 * @param value any type (string, number, etc.)
 * @param delay delay in ms (default = 500)
 * @returns debounced value
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}
